var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// React
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Modal, ModalMedia, ModalFooter } from '@lux/modal';
import { FunctionColor, TitlePreset } from '@lux/title';
import { PlusTierPill, Size } from '@lux/plus-badge';
import { ChevronLeft, IconSize } from '@lux/zds-icons';
import { Preset, Text } from '@lux/text';
// Pegasus
import { Translate, TranslateScope, useTranslate } from '@pegasus/translation';
import { setCookie } from '@pegasus/utils';
// Browsing
import { trackSelectContent, trackViewContent } from '@browsing/tracking';
import { Close } from '@browsing/icons';
// Local
import { ModalDescription, ModalTitle, ModalOverlay, ModalWrapper, BirthdayImage, PlusBadgeWrapper, TermsWrapper, TermsHeader, TermsHeaderBack, TermsContent, PlusBadgeContainer, CloseButton, ValidUntilText, TermsLinkText, TermsTitle, } from './styles';
import { ModalState } from '../../types';
import { formatISODateToMMDDYYYY } from '../../utils';
import { ONE_DAY } from '../../constants';
export var BirthdayVoucherModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, customerName = _a.customerName, customerIncentive = _a.customerIncentive, tier = _a.tier;
    var _b = useState(ModalState.BIRTHDAY), modalState = _b[0], setModalState = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var translate = useTranslate();
    var formattedEndDate = customerIncentive.end_at
        ? formatISODateToMMDDYYYY(customerIncentive.end_at)
        : '';
    // Use intersection observer for more accurate visibility tracking
    var _d = useInView({
        threshold: 0.1, // Track when 10% of modal is visible
        triggerOnce: true, // Only track the first time it comes into view
    }), intersectionRef = _d.ref, inView = _d.inView;
    useEffect(function () {
        if (inView && open) {
            trackViewContent('birthday_voucher_modal');
        }
    }, [inView, open]);
    var handleClaimVoucher = function () { return __awaiter(void 0, void 0, void 0, function () {
        var couponCode;
        return __generator(this, function (_a) {
            setIsLoading(true);
            trackSelectContent('birthday_voucher_modal', 'click', {
                contentId: 'claim_voucher',
            });
            // Check if coupon incentive is available
            if (!customerIncentive.coupon.code) {
                setIsLoading(false);
                return [2 /*return*/];
            }
            // Check if coupon is already applied
            if (customerIncentive.coupon.is_applied) {
                setIsLoading(false);
                setModalState(ModalState.SUCCESS);
                return [2 /*return*/];
            }
            couponCode = customerIncentive.coupon.code;
            // Set the coupon cookie that checkout middleware will detect (3 days expiry)
            setCookie('coupon', couponCode, Date.now() + ONE_DAY * 3, '/');
            setIsLoading(false);
            setModalState(ModalState.SUCCESS);
            return [2 /*return*/];
        });
    }); };
    var handleContinueShopping = function () {
        trackSelectContent('birthday_voucher_modal', 'click', {
            contentId: 'continue_shopping',
        });
        onClose();
    };
    var handleCloseModal = function () {
        trackSelectContent('birthday_voucher_modal', 'click', {
            contentId: 'close',
        });
        onClose();
    };
    var handleShowTerms = function () {
        trackSelectContent('birthday_voucher_modal', 'click', {
            contentId: 'terms_and_conditions',
        });
        setModalState(ModalState.TERMS_AND_CONDITIONS);
    };
    var handleBackFromTerms = function () {
        setModalState(ModalState.BIRTHDAY);
    };
    var renderPlusBadge = function () { return (React.createElement(PlusBadgeContainer, null,
        React.createElement(TranslateScope, { path: "plus.loyalty" },
            React.createElement(PlusBadgeWrapper, null,
                React.createElement(PlusTierPill, { tier: tier, size: Size.M, dynamicFontSize: true },
                    React.createElement(Translate, { message: "tier.".concat(tier) })))),
        React.createElement(CloseButton, { onClick: handleCloseModal },
            React.createElement(Close, null)))); };
    var renderBirthdayModal = function () {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(ModalMedia, null,
                React.createElement(BirthdayImage, { src: "https://img01.ztat.net/zl-campaignC/plus/BirthdayVoucherForm.jpg?imwidth=500", alt: translate('claimForm.celebrationTitle') })),
            React.createElement(ModalTitle, { preset: TitlePreset.S, presetSm: TitlePreset.XS },
                React.createElement(Translate, { message: "claimForm.celebrationTitle", params: { customerName: customerName } })),
            React.createElement(ModalDescription, null,
                React.createElement(Translate, { message: "claimForm.celebrationMessage", params: { discountPercent: customerIncentive.content.discount_label } })),
            React.createElement(ModalFooter, { primaryAction: {
                    children: React.createElement(Translate, { message: "claimForm.claiming" }),
                    onClick: isLoading ? undefined : handleClaimVoucher,
                } }),
            React.createElement(ValidUntilText, { preset: Preset.XS },
                React.createElement(Translate, { message: "claimForm.validUntil" }),
                " ",
                formattedEndDate,
                React.createElement("br", null),
                React.createElement(TermsLinkText, { as: "span", preset: Preset.XS, onClick: handleShowTerms }, (_a = customerIncentive.legal_terms) === null || _a === void 0 ? void 0 : _a.title))));
    };
    var renderTermsAndConditions = function () {
        var _a, _b;
        return (React.createElement(TermsWrapper, null,
            React.createElement(TermsHeader, null,
                React.createElement(TermsHeaderBack, { onClick: handleBackFromTerms, "aria-label": translate('header.myaccount-submenu.go-back') },
                    React.createElement(ChevronLeft, { size: IconSize.S, color: FunctionColor.function80 })),
                React.createElement("div", null,
                    React.createElement(Translate, { message: "claimForm.termsAndConditions" })),
                React.createElement(CloseButton, { onClick: handleCloseModal },
                    React.createElement(Close, null))),
            React.createElement(TermsTitle, { preset: TitlePreset.M }, (_a = customerIncentive.legal_terms) === null || _a === void 0 ? void 0 : _a.title),
            React.createElement(TermsContent, null,
                React.createElement(Text, { preset: Preset.M }, (_b = customerIncentive.legal_terms) === null || _b === void 0 ? void 0 : _b.description))));
    };
    var renderSuccessModal = function () { return (React.createElement(React.Fragment, null,
        React.createElement(ModalMedia, null,
            React.createElement(BirthdayImage, { src: "https://img01.ztat.net/zl-campaignC/plus/BirthdayVoucherForm.jpg?imwidth=500", alt: translate('mylounge.birthdayVoucher.claimSuccess.successTitle') })),
        React.createElement(ModalTitle, { preset: TitlePreset.S, presetSm: TitlePreset.XS },
            React.createElement(Translate, { message: "claimSuccess.successTitle" })),
        React.createElement(ModalDescription, null,
            React.createElement(Translate, { message: "claimSuccess.successMessage" })),
        React.createElement(ModalFooter, { primaryAction: {
                children: React.createElement(Translate, { message: "claimSuccess.continueShopping" }),
                onClick: handleContinueShopping,
            } }))); };
    if (!open) {
        return null;
    }
    return (React.createElement(Modal, { dismissable: false, open: open, onOpenChange: onClose, purpose: "NON_COMMERCIAL", role: "dialog", size: "S", sizeSm: "S" },
        React.createElement(ModalOverlay, { dismissLabel: translate('shared.close'), onClick: handleCloseModal },
            React.createElement(ModalWrapper, { ref: intersectionRef, onClick: function (e) { return e.stopPropagation(); } },
                modalState !== ModalState.TERMS_AND_CONDITIONS && renderPlusBadge(),
                React.createElement(TranslateScope, { path: "birthdayVoucher" },
                    modalState === ModalState.TERMS_AND_CONDITIONS &&
                        renderTermsAndConditions(),
                    modalState === ModalState.BIRTHDAY && renderBirthdayModal(),
                    modalState === ModalState.SUCCESS && renderSuccessModal())))));
};
